// extracted by mini-css-extract-plugin
export default {"searchClearIcon":"SearchInput_searchClearIcon__VwJHO","searchIcon":"SearchInput_searchIcon__oxIn1"};